export const linkQuery = `
    _type,
    label,
    type,
    type == 'internal' => {
        internal -> {
            _id,
            metadata {
                slug
            }
        }
    },
    type == 'external' => {
        external
    }
`